export const INITIAL_STATE_DATA_REF = {
  id: "",
  descricao: "",
  ref: "",
  refObject: {
    tipo_emissao: 1,
    finalidade: 0,
    codigo_servico: "",
    natureza_operacao: "",
    exigibilidade_iss: "",
    iss_retido: "",
    codigo_cnae: "",
    codigo_tributacao_municipio: "",
    cod_indicador_operacao: "",
    consumidor_final: "",
    responsavel_retencao_iss: "",
    codigo_nbs: "",
    tributacao_iss: "1",
    cst_pis_cofins: "00",
    ibs_cbs: {
      situacao_tributaria: null,
      classificacao_tributaria: null,
      ibs_estadual: {
        aliquota_diferimento: "",
      },
      ibs_municipal: {
        aliquota_diferimento: "",
      },
      cbs: {
        aliquota_diferimento: "",
      },
    },
    tipo: "nfse",
    iss: 0,
    pis: 0,
    cofins: 0,
    inss: 0,
    ir: 0,
    csll: 0,
    deducao: "",
  }
}